import {DUET_SESSIONS_PER_PERIOD} from '../../../lib/constants/duet';
import {getBrandName} from '../components/Brand';

/**
 * Features for various Aced products, to be used with PlanCard
 */
export const freeFeatures = [
  {
    label: 'Sample lessons',
    tooltip: `Get a taste of what ${getBrandName()} has to offer`,
  },
  {
    label: `${DUET_SESSIONS_PER_PERIOD} peer mocks per month`,
    tooltip: 'Schedule mock interviews with peers',
  },
  {
    label: 'Sample questions',
    tooltip: 'Limited access to the most up-to-date database of real interview questions',
  },
  {
    label: 'Basic job referrals',
    tooltip: 'Get more interviews with access to our network of referrers at top companies',
  },
];

export const membershipFeatures = [
  {
    label: 'All courses',
    tooltip: 'Get access to our entire course catalog for interviews and career skills',
  },
  {
    label: 'Video and written solutions',
    tooltip: 'Watch real interviewers answer questions and give in-depth career talks in our premium video content',
  },
  {
    label: 'Company-specific guides',
    tooltip: 'Stay up-to-date on interview loops, formats, and what to expect at specific companies',
  },
  {
    label: 'Real interview experiences',
    tooltip: 'Access our database of real, detailed interview experiences shared by candidates at top companies',
  },
  {
    label: 'Unlimited peer mocks',
    tooltip: 'Schedule unlimited mock interviews with peers',
  },
  {
    label: 'Full question database',
    tooltip: 'Access the most up-to-date database of real interview questions and discuss with the community',
  },
  {
    label: 'Priority job referrals',
    tooltip: 'Get more interviews with unlimited priority access to our network of referrers at top companies',
  },
  {
    label: 'Discord community',
    tooltip: 'Join our private members-only Discord to discuss interviewing tips, strategies, and find study buddies',
  },
];

export const expertMembershipFeatures = [
  {
    label: 'Everything in Membership',
    tooltip: 'All courses, unlimited peer mocks, the full question database, and more',
  },
  {
    label: 'AI mock interviews',
    tooltip: 'Get feedback from an AI interviewer trained on our curriculum',
  },
  {
    label: 'AI interview feedback',
    tooltip: 'Get feedback for your peer mocks from an AI observer trained on our curriculum',
  },
  {
    label: 'Chat with AI coach',
    tooltip: 'Ask our AI assistant Ace anything about your interview prep, courses, and questions',
  },
];

export const financeFreeFeatures = [
  {
    label: 'Sample lessons',
    tooltip: 'Free lessons from each module of the IB course',
  },
  {
    label: `${DUET_SESSIONS_PER_PERIOD} peer mocks per month`,
    tooltip: 'Schedule mock interviews with peers',
  },
  {
    label: 'Sample questions',
    tooltip: 'A preview of our IB interview question database',
  },
];

export const financeMembershipFeatures = [
  {
    label: 'Full IB course, 90+ lessons',
    tooltip: 'Written lessons on networking, behaviorals, accounting, valuation, LBO, and M&A',
  },
  {
    label: '180+ expert mock interview videos',
    tooltip: 'Watch analysts at top banks answer the questions that come up most',
  },
  {
    label: '5+ full-length superday mocks',
    tooltip: 'Full simulations of every stage, first rounds through superdays',
  },
  {
    label: 'Bank guides & grading rubrics',
    tooltip: 'What to expect at each bank, plus the rubrics interviewers grade on',
  },
  {
    label: 'Full question database, 320+ questions',
    tooltip: 'Real IB interview questions from recent recruiting cycles',
  },
  {
    label: 'Real interview experiences',
    tooltip: 'Write-ups from candidates on how their interviews actually went',
  },
  {
    label: 'Unlimited peer mocks',
    tooltip: 'We match you with other IB candidates for live practice',
  },
];

export const financeExpertMembershipFeatures = [
  {
    label: 'Everything in Pro',
    tooltip: 'Every feature in the Pro membership, plus the AI coaching suite',
  },
  {
    label: 'AI mock interviews',
    tooltip: 'Practice any question with an AI interviewer, anytime',
  },
  {
    label: 'AI interview feedback',
    tooltip: 'Instant scoring and feedback on your answers',
  },
  {
    label: 'Chat with AI coach',
    tooltip: 'Ask questions and get guidance between sessions',
  },
];

export const resumeReviewFeatures = [
  {
    label: 'Reviewed by senior tech recruiters & hiring managers',
  },
  {
    label: 'Get review in 5 business days or less',
  },
  {
    label: 'Money-back guarantee',
    tooltip: 'Full refund if not satisfied',
  },
];

export const resumeReviewCallFeatures = [
  {
    label: '1-on-1 session with a senior tech recruiter / hiring manager',
  },
  {
    label: 'Schedule anytime',
    tooltip: 'Book a session after purchase',
  },
  {
    label: 'Money-back guarantee',
    tooltip: 'Full refund if not satisfied',
  },
];
